// Local translations
export const T = {
  en_GB: {
    compliance: "Compliance",
    flowApprovals: "Flow Approvals",
    description:
      "Flow instances waiting for compliance approval. Open one to review the documents and decide.",
    empty: "Nothing here.",
    client: "Client",
    flow: "Flow",
    requested: "Requested",
    requestedBy: "By",
    status: "Status",
    decided: "Decided",
    filterAll: "All",
    filterTodo: "To do",
    filterApproved: "Approved",
    filterRejected: "Rejected",
    statusPending: "Pending",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    statusWithdrawn: "Withdrawn",
  },
  nb_NO: {
    compliance: "Compliance",
    flowApprovals: "Flytgodkjenninger",
    description:
      "Flytinstanser som venter på compliance-godkjenning. Åpne en for å vurdere dokumentene og beslutte.",
    empty: "Ingenting her.",
    client: "Kunde",
    flow: "Flyt",
    requested: "Forespurt",
    requestedBy: "Av",
    status: "Status",
    decided: "Besluttet",
    filterAll: "Alle",
    filterTodo: "Å gjøre",
    filterApproved: "Godkjent",
    filterRejected: "Avvist",
    statusPending: "Venter",
    statusApproved: "Godkjent",
    statusRejected: "Avvist",
    statusWithdrawn: "Trukket",
  },
} as const;
